'use client';
import IconArrowLeft from '@/assets/icons/icon-cart-arrow-left.svg';
import IconArrowRight from '@/assets/icons/icon-cart-arrow-right.svg';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useRef } from 'react';
import styles from './tabs-carousel.module.scss';

type TabProps = {
  tab: string;
  setTab(value: string): void;
  similarProducts: any[];
};

const TabsCarousel = ({ similarProducts, tab, setTab }: TabProps) => {
  const splideRef = useRef<any>(null);

  const handleChangeTabCategory = (tabCategory: string) => {
    setTab(tabCategory);
  };

  const goToNextSlide = () => {
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.go('>');
    }
  };

  const goToPrevSlide = () => {
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.go('<');
    }
  };

  const categories = similarProducts
    ?.filter(
      (item, index, array) =>
        item?.category?.id !== array[index - 1]?.category?.id
    )
    .map(item => ({
      id: item?.category?.id,
      category: item?.category?.name,
    }));

  return (
    <div className={styles.carousel}>
      <Splide
        ref={splideRef}
        options={{
          type: 'slide',
          rewind: true,
          pagination: false,
          arrows: false,
          gap: '8px',
          drag: true,
          snap: true,
          perPage: 4,
          perMove: 1,
          speed: 400,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          fixedWidth: 'auto',

          breakpoints: {
            1024: {
              perPage: 3,
              gap: '8px',
              focus: 'left',
            },
            768: {
              perPage: 3,
              gap: '8px',
            },
            480: {
              perPage: 3,
              focus: 'left',
              trimSpace: false,
              gap: '8px',
              dragMinThreshold: 5,
              flickPower: 100,
              touchAngle: 45,
              dragRestingState: 'ready',
            },
          },
        }}
        hasTrack={false}
      >
        <SplideTrack>
          {categories.map(
            ({ id, category }: { id: string; category: string }) => (
              <SplideSlide key={id}>
                <button
                  type="button"
                  onClick={() => handleChangeTabCategory(id)}
                  className={`${styles.slide} ${tab === id && styles.slideActive}`}
                >
                  <div className={styles.texts}>
                    <h3>{category}</h3>
                  </div>
                </button>
              </SplideSlide>
            )
          )}
        </SplideTrack>
        <button
          type="button"
          className={styles.carouselPrevButton}
          onClick={goToPrevSlide}
          aria-label="Previous slide"
        >
          <IconArrowRight />
        </button>
        <button
          type="button"
          className={styles.carouselNextButton}
          onClick={goToNextSlide}
          aria-label="Next slide"
        >
          <IconArrowLeft />
        </button>
      </Splide>
    </div>
  );
};

export default TabsCarousel;
